var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKdb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 147,
    viewBox: "0 0 500 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 147,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.283 47.1769V57.364H465.598V47.1769H460.329V75.2311H465.598V61.9645H470.283V76.2551H475.544V47.1769H470.283ZM456.994 78.1826C446.882 78.1826 438.653 83.1293 438.653 89.2055C438.653 95.2817 446.882 100.236 456.994 100.236C467.105 100.236 475.327 95.2892 475.327 89.2055C475.327 83.1218 467.105 78.1826 456.994 78.1826ZM456.994 95.6732C449.933 95.6732 444.192 92.7744 444.192 89.2055C444.192 85.6366 449.933 82.7228 456.994 82.7228C464.054 82.7228 469.81 85.6291 469.81 89.2055C469.81 92.7819 464.062 95.6732 456.994 95.6732ZM359.518 83.8898H335.391V78.0546H329.74V96.2454C329.74 97.691 331.074 98.9108 332.648 98.9108H365.11V78.0546H359.518V83.8898ZM359.466 94.3028H335.398V88.4375H359.466V94.3028ZM359.518 57.4318H348.86C347.638 51.4309 342.017 47.0865 335.428 47.0865C327.881 47.0865 321.742 52.7938 321.742 59.796C321.742 66.7983 327.881 72.498 335.428 72.498C342.092 72.498 347.713 68.1084 348.882 62.0322H359.518V74.5384H365.11V47.1769H359.518V57.4318ZM335.428 68.0105C331.051 68.0105 327.484 64.3287 327.484 59.796C327.484 55.2634 331.044 51.574 335.428 51.574C339.813 51.574 343.373 55.2634 343.373 59.796C343.373 64.3287 339.813 68.0105 335.428 68.0105ZM388.57 82.4442H382.971V96.2379C382.971 97.691 384.305 98.9108 385.886 98.9108H419.922V94.3028H388.57V82.4366V82.4442ZM377.154 78.4311H424.03V73.8231H377.154V78.4311ZM400.592 69.3131C410.89 69.3131 419.278 64.0425 419.278 57.5673C419.278 51.0921 410.898 45.8367 400.592 45.8367C390.286 45.8367 381.921 51.0997 381.921 57.5673C381.921 64.035 390.301 69.3131 400.592 69.3131ZM400.592 50.3844C407.84 50.3844 413.739 53.6069 413.739 57.5673C413.739 61.5278 407.84 64.7729 400.592 64.7729C393.344 64.7729 387.453 61.5428 387.453 57.5673C387.453 53.5919 393.344 50.3844 400.592 50.3844Z",
    fill: "#003C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.135 75.0127C271.779 72.2118 276.306 67.89 278.884 62.7776L278.705 62.6872L278.892 62.7776L278.922 62.7098L278.952 62.7776C281.53 67.8975 286.05 72.2193 291.709 75.0202L294.325 71.4212C291.311 69.6744 287.264 66.6326 284.551 61.8891C281.942 57.123 281.77 51.4761 281.77 50.0229V48.1556H276.051V50.0304C276.051 51.5363 275.871 57.1381 273.278 61.8966C270.58 66.625 266.532 69.6669 263.512 71.4212L266.135 75.0202V75.0127Z",
    fill: "#003C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.496 80.9985H272.904V96.268C272.904 97.7437 274.253 98.9484 275.82 98.9484H307.885V94.3329H278.496V80.9985Z",
    fill: "#003C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.353 47.222H301.754V84.8159H307.353V64.9009H315.035V60.2929H307.353V47.222Z",
    fill: "#003C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.186 49.1194H148.536L148.476 49.1721L123.704 72.1666V49.1269H117.873L117.881 98.9182H123.704V75.472L151.099 98.9182H160.356L130.15 73.7176L157.186 49.1194Z",
    fill: "#003C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.812 73.1379C248.559 71.361 252.255 67.9879 252.247 61.7461V61.603C252.247 58.3805 251.1 55.7076 249.024 53.5542C246.161 50.7458 241.686 49.1119 236.035 49.1044L214.898 49.1194V98.9183H236.949C247.743 98.9032 254.975 93.8435 254.99 85.2375V85.0945C254.99 78.416 250.448 74.945 244.812 73.1455V73.1379ZM220.977 76.4734H236.102C244.639 76.496 248.972 79.5303 248.972 84.7406V84.8761C248.972 90.2445 244.49 93.4821 237.084 93.5047H220.782V54.5255H235.54C242.518 54.5481 246.213 57.6351 246.228 62.3861V62.5141C246.221 68.1761 241.746 71.1201 235.121 71.1427H224.148L220.977 76.4734Z",
    fill: "#003C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.365 49.1194H164.096V98.9182H181.365C189.137 98.9182 195.718 96.2002 200.358 91.7278C204.997 87.2629 207.688 81.0286 207.688 74.0339V73.8908C207.688 66.8886 204.997 60.6919 200.358 56.2496C195.718 51.8073 189.137 49.1269 181.357 49.1269L181.365 49.1194ZM201.534 74.1543C201.527 84.9965 193.702 93.3541 181.365 93.3691H170.047V54.6911H181.365C193.694 54.6986 201.527 63.1917 201.534 74.0339V74.1619V74.1543Z",
    fill: "#003C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7081 54.8341C37.1791 57.8835 38.7381 64.1705 40.6644 67.1972L67.1825 109.007H47.8074C44.7493 109.007 41.7587 107.253 40.447 105.228L25.9962 82.4064C24.6396 80.2756 24.7071 76.9025 25.9962 74.8395L38.7081 54.8341Z",
    fill: "url(#paint0_radial_0_3850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8997 75.4344C49.1951 76.5412 48.558 79.1764 49.6299 81.3148L40.6731 67.1973C38.7393 64.1705 37.1878 57.8835 38.7168 54.8342L40.3058 52.3269C41.7449 50.038 44.4207 48.5397 47.801 48.5397H66.8539L49.9072 75.4344H49.8997Z",
    fill: "url(#paint1_radial_0_3850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2637 93.1659C90.7928 90.1165 89.2338 83.8295 87.3075 80.8103L60.7969 39H80.172C83.2226 39 86.2207 40.7468 87.5323 42.7647L101.991 65.5935C103.347 67.7168 103.28 71.0899 101.983 73.153L89.2712 93.1583L89.2637 93.1659Z",
    fill: "url(#paint2_radial_0_3850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0798 72.5657C78.7844 71.4589 79.4215 68.8236 78.3572 66.6853L87.3139 80.8103C89.2477 83.8295 90.7992 90.124 89.2702 93.1659L87.6812 95.6731C86.2421 97.9621 83.5663 99.4604 80.1935 99.4604H61.1406L78.0873 72.5657H78.0798Z",
    fill: "url(#paint3_radial_0_3850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.38 51.1599H446.644V46.5369H441.015V51.1599H431.129V55.5796H436.046L435.731 55.8582C433.43 57.9362 432.156 60.7296 432.156 63.7037C432.156 69.7196 437.395 74.6061 443.856 74.6061C450.317 74.6061 455.541 69.7196 455.541 63.7037C455.541 60.7296 454.274 57.9362 451.966 55.8582L451.651 55.5796H456.373V51.1599H456.38ZM443.856 70.2994C440.318 70.2994 437.432 67.2274 437.432 63.4552C437.432 59.683 440.318 56.6186 443.856 56.6186C447.394 56.6186 450.279 59.683 450.279 63.4552C450.279 67.2274 447.386 70.2994 443.856 70.2994Z",
    fill: "#003C7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_3850",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.6122 67.5609) rotate(-90) scale(51.669 56.3337)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7DFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#BFDBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A9D0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#92C5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#7FB4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4F89C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3471B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#215EA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003C7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_0_3850",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.4388 49.0675) scale(36.1738 36.3383)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7DFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#BFDBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A9D0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#92C5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#7FB4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4F89C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3471B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#215EA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003C7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_0_3850",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.36 80.4233) rotate(90) scale(51.6595 56.3233)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7DFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#BFDBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A9D0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#92C5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#7FB4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4F89C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3471B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#215EA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003C7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_0_3850",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.2651 98.9326) rotate(180) scale(36.1772 36.3417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7DFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#BFDBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A9D0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#92C5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#7FB4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4F89C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3471B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#215EA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003C7F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 450.545,
    height: 70,
    fill: "white",
    transform: "translate(25 39)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKdb);
export default __webpack_public_path__ + "static/media/kdb 산업은행.6a429a71a1f171dd8757554e840c2b03.svg";
export { ForwardRef as ReactComponent };